import PropTypes from "prop-types"
import OPTooltip from "components/material/tooltip"

export default function PeriodSelectorOption({ label, period, value, select, disabled = false, disabledReason = null }) {
  const className = period === value ? "option selected" : "option"

  if (disabled) {
    return (
      <OPTooltip title={disabledReason} placement="right">
        <div className={`${className} option-disabled`} aria-disabled="true">{label}</div>
      </OPTooltip>
    )
  }

  return <div className={className} onClick={() => { select(value) }}>{label}</div>
}

PeriodSelectorOption.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  select: PropTypes.func.isRequired,
  period: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  disabledReason: PropTypes.string,
}
